var windowW       = $(window).width();
var windowH       = $(window).innerHeight();

//preload
import {preload} from "../include/module";
preload();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

//pageTop
import {pageTop} from "../include/module";
pageTop();

//showMovie
// import {showMovie} from "../include/module";
// showMovie();

//tabSwitchingCampaign
import {tabSwitchingCampaign} from "../include/module";
tabSwitchingCampaign();

//anchorLink
import {anchorLink} from "../include/module";
anchorLink();


$(window).on('load' , function() {
  bgNoise();

  $('.anim_Item-first').each(function(){
    $(this).addClass("show");
  });

  setTimeout(function(){
      showItem();
  },800);

});



function bgNoise(){

  var canvas = document.getElementById('noise'),
  ctx = canvas.getContext('2d');

  function resize() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }
  resize();
  window.onresize = resize;

  function noise(ctx) {

  var w = ctx.canvas.width,
  h = ctx.canvas.height,
  idata = ctx.createImageData(w, h),
  buffer32 = new Uint32Array(idata.data.buffer),
  len = buffer32.length,
  i = 0;

  for(; i < len;)
    buffer32[i++] = ((255 * Math.random())|0) << 24;

    ctx.putImageData(idata, 0, 0);
  }

  var toggle = true;

  // added toggle to get 30 FPS instead of 60 FPS
  (function loop() {
    toggle = !toggle;
    if (toggle) {
      requestAnimationFrame(loop);
      return;
    }
    noise(ctx);
    requestAnimationFrame(loop);
  })();

}

/*******************************************************

showItem

********************************************************/
const showItem = () => {
  var targetPositionAdd;

  targetPositionAdd = 30;

  var scrollPosition = $(window).scrollTop();

  $(window).on("load resize", function () {
    windowW       = $(window).width();
    windowH       = $(window).innerHeight();
  });

  //ファーストビュー内にあるアイテム
  $('.anim_Item').each(function(){
    var targetPosition = $(this).offset().top;
    if(targetPosition < (windowH + scrollPosition)){
      $(this).addClass("show");
    }
  });

  //ファーストビューより下にあるアイテム（スクロールで表示）
  $(window).on('scroll',function(){
    scrollPosition = $(window).scrollTop();
    $('.anim_Item').each(function(){
      var targetPosition = $(this).offset().top;
      if(scrollPosition > targetPosition - windowH + targetPositionAdd){
        $(this).addClass("show");
      }
    });

    //スクロール誘導矢印を消す
    // $(".opening_Item").addClass("hidden");
  });
};



// WEBPACK FOOTER //
// ./src/assets/js/nextband/script.js